<template>
  <div class="page-empty" :role="error ? 'alert' : 'status'">
    <div class="page-empty__icon"><el-icon :size="28"><Warning v-if="error" /><Lock v-else-if="kind === 'permission'" /><Tools v-else-if="kind === 'construction'" /><Search v-else-if="kind === 'search'" /><Files v-else /></el-icon></div>
    <h3>{{ resolvedTitle }}</h3>
    <p v-if="description">{{ description }}</p>
    <div v-if="$slots.default || error" class="page-empty__actions"><slot><el-button v-if="error" @click="$emit('retry')">重新加载</el-button></slot></div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { Files, Lock, Search, Tools, Warning } from '@element-plus/icons-vue'
const props = withDefaults(defineProps<{ title?: string; description?: string; kind?: 'empty' | 'search' | 'permission' | 'construction'; error?: boolean }>(), { kind: 'empty' })
defineEmits<{ retry: [] }>()
const resolvedTitle = computed(() => props.title || (props.error ? '加载失败' : { empty: '暂无数据', search: '未找到匹配结果', permission: '暂无访问权限', construction: '功能建设中' }[props.kind]))
</script>
<style scoped>
.page-empty { min-height: 220px; padding: 40px 24px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; }
.page-empty__icon { display: grid; place-items: center; width: 64px; height: 64px; border-radius: 16px; background: var(--ui-surface-muted); color: var(--ui-text-muted); margin-bottom: 16px; }
h3 { font-size: 15px; font-weight: 600; color: var(--ui-text-secondary); }
p { max-width: 420px; margin-top: 6px; color: var(--ui-text-muted); line-height: 1.7; }
.page-empty__actions { margin-top: 20px; }
</style>
